@if(isParticipantFlow && timesheets && timesheets.length > 0) {
<ppl-accordion [title]="'Timesheets Waiting For Approval'" [isOpen]="true">
    <ul class="todo-list">
        @for(timesheet of timesheets; track $index) {
        <li class="todo-item">
            <span class="todo-item-title">Timesheet pending for <strong>{{timesheet.providerName}}</strong>
                <strong>({{timesheet.providerPplId}})</strong> for pay period ({{timesheet.payrollStartDate}} -
                {{timesheet.payrollEndDate}})</span>
            <span class="todo-status">Pending</span>
        </li>
        }
    </ul>
</ppl-accordion>
}

<ppl-accordion [title]="'To Do List'" [isOpen]="true">
    @if((checkListData && checkListData.length > 0) || (prvdrAssociations && prvdrAssociations.length > 0) || (linkedChecklists && linkedChecklists.length > 0) || (serviceCredentials && serviceCredentials.length > 0)) {
    <ul class="todo-list">
        <!-- Checklist entries first -->
        @if(checkListData && checkListData.length > 0) {
            @for(checkList of checkListData; track $index) {
            <li class="todo-item todo-item-stacked">
                <div class="todo-item-main">
                    <span class="todo-item-title">Checklist <strong>{{checkList.name}}</strong> for
                        <strong>{{checkList.for}}</strong></span>
                    <span class="todo-status">Pending</span>
                </div>
                @if(checkList.questions?.length > 0) {
                <ul class="todo-pending-questions">
                    @for(question of checkList.questions; track $index) {
                    <li>{{question}}</li>
                    }
                </ul>
                }
            </li>
            }
        }

        @if(prvdrAssociations && prvdrAssociations.length > 0) {
            @for(assoc of prvdrAssociations; track $index) {
                @for(group of assoc.checklistGroups; track $index) {
                <li class="todo-item todo-item-stacked">
                    <div class="todo-item-main">
                        @if(isPA) {
                        <span class="todo-item-title">Checklist for {{assoc.providerTypeLabel === 'Personal Assistant' ? 'Independent Provider' : assoc.providerTypeLabel}} Association to
                            {{assoc.participantFirstName}} {{assoc.participantLastName}}
                            <strong>({{assoc.participantPplId}})</strong></span>
                        } @else {
                        <span class="todo-item-title">Checklist for {{assoc.providerTypeLabel === 'Personal Assistant' ? 'Independent Provider' : assoc.providerTypeLabel}} to
                            {{assoc.participantFirstName}} {{assoc.participantLastName}}
                            <strong>({{assoc.participantPplId}})</strong></span>
                        }
                        <span class="todo-status">Pending</span>
                    </div>
                    @if(group.pendingSections?.length > 0) {
                    <ul class="todo-pending-list">
                        @for(section of group.pendingSections; track section.category) {
                        <li>
                            <span class="todo-pending-category">{{section.category}}</span>
                            <ul class="todo-pending-questions">
                                @for(question of section.questions; track $index) {
                                <li>{{question}}</li>
                                }
                            </ul>
                        </li>
                        }
                    </ul>
                    }
                </li>
                }
            }
        }

        <!-- Linked Employer/Provider checklists -->
        @if(linkedChecklists && linkedChecklists.length > 0) {
            @for(linked of linkedChecklists; track $index) {
                @for(group of linked.checklistGroups; track $index) {
                <li class="todo-item todo-item-stacked">
                    <div class="todo-item-main">
                        <span class="todo-item-title">Checklist for {{linked.counterpartyType}}
                            {{linked.counterpartyName}}
                            <strong>({{linked.counterpartyPplId}})</strong></span>
                        <span class="todo-status">Pending</span>
                    </div>
                    @if(group.pendingSections?.length > 0) {
                    <ul class="todo-pending-list">
                        @for(section of group.pendingSections; track section.category) {
                        <li>
                            <span class="todo-pending-category">{{section.category}}</span>
                            <ul class="todo-pending-questions">
                                @for(question of section.questions; track $index) {
                                <li>{{question}}</li>
                                }
                            </ul>
                        </li>
                        }
                    </ul>
                    }
                </li>
                }
            }
        }

        <!-- Form entries next -->
        @if(prvdrAssociations && prvdrAssociations.length > 0) {
            @for(assoc of prvdrAssociations; track $index) {
                @if(assoc.onDutyMealBreakPending) {
                <li class="todo-item">
                    <span class="todo-item-title">Form <strong>{{assoc.onDutyMealBreakLabel}}</strong> for Participant
                        {{assoc.participantFirstName}} {{assoc.participantLastName}}
                        <strong>({{assoc.participantPplId}})</strong></span>
                    <span class="todo-status">Pending</span>
                </li>
                }
                @if(assoc.hcbsFormPending) {
                <li class="todo-item">
                    <span class="todo-item-title">Form <strong>{{assoc.hcbsFormLabel}}</strong> for Participant
                        {{assoc.participantFirstName}} {{assoc.participantLastName}}
                        <strong>({{assoc.participantPplId}})</strong></span>
                    <span class="todo-status">Pending</span>
                </li>
                }
            }
        }

        @if(serviceCredentials && serviceCredentials.length > 0) {
            @for(sc of serviceCredentials; track $index) {
            <li class="todo-item">
                <span class="todo-item-title">Service Credentials for Participant
                    {{sc.participantFullName}}
                    <strong>({{sc.participantPplId}})</strong></span>
                <span class="todo-status">Pending</span>
            </li>
            }
        }
    </ul>
    }
    @else {
    <nz-alert class="mb-2" nzType="info" nzMessage="No pending items for you." nzShowIcon></nz-alert>
    }
</ppl-accordion>